import { Skeleton } from "@mui/material"
import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import { useAccountSummary } from "@/App/Equities/shared/services/account"
import { formatCurrency } from "@/App/Equities/shared/utils"
import { Stack, Typography } from "@/generated/material"

import { HEADER_LOCATORS } from "./locators"

export const AccountSummary = () => {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      gap="md"
      paddingX="2xl"
      paddingBottom="xs"
      borderRadius={({ uisk }) => uisk.radius.sm}
      data-testid={HEADER_LOCATORS.main}
    >
      <Typography
        variant="Display xs/Regular"
        data-testid={HEADER_LOCATORS.accountName}
        color="text-tertiary"
      >
        {t("adaptive.shortName")}
      </Typography>

      <Typography
        variant="Display xs/Medium"
        data-testid={HEADER_LOCATORS.accountValue}
        color="text-secondary"
      >
        <Subscribe fallback={<Skeleton sx={{ width: "60px" }} />}>
          <AccountValue />
        </Subscribe>
      </Typography>
    </Stack>
  )
}

export const AccountValue = () => {
  return formatCurrency(useAccountSummary().portfolioValue)
}
